import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-435a319a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "com_pagenation1" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", {
        class: _normalizeClass(["prev", { disabled: _ctx.currentPage <= 1 }])
      }, [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage - 1)), ["prevent"]))
        }, "前の" + _toDisplayString(_ctx.itemsPerPage) + "件", 1)
      ], 2),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
        return (_openBlock(), _createElementBlock("li", {
          key: page,
          class: _normalizeClass(["item", { active: _ctx.currentPage === page, ellipsis: page === '...' }])
        }, [
          (page !== '...')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                onClick: _withModifiers(($event: any) => (_ctx.changePage(page)), ["prevent"])
              }, _toDisplayString(page), 9, _hoisted_2))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(page), 1))
        ], 2))
      }), 128)),
      _createElementVNode("li", {
        class: _normalizeClass(["next", { disabled: _ctx.currentPage >= _ctx.totalPages }])
      }, [
        _createElementVNode("a", {
          href: "#",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.changePage(_ctx.currentPage + 1)), ["prevent"]))
        }, "次の" + _toDisplayString(_ctx.itemsPerPage) + "件", 1)
      ], 2)
    ])
  ]))
}